import {type IAsset} from '@netx/core-asset-next/schema';
import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SearchVisualPref} from './constants';

export const visualSearchEnabled = () =>
	getPreference(SearchVisualPref.ENABLED, true);

export const canVisualSearch = (asset?: IAsset) =>
	visualSearchEnabled() && asset?.fileFormatFamily.includes('image') === true;
